import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import Cookies from "js-cookie";
import { RetryOnError, verifyToken } from "../utils/VerifyToken";
import { checkForAuthorization } from "utils/index";


export const FetchAllSubscriptions = ({ page = 1, limit = 10, search = "", queryParams = {} }) => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-listing-template-all-FetchAllSubscriptions-fetch', page, limit, search, queryParams],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/admin/subscriptions`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
                params: {
                    page,
                    limit,
                    search,
                    ...queryParams
                }
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data,'values new')
            return data?.data
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchAllPurchases = ({ page = 1, limit = 10, search = "", queryParams = {} }) => {
    // console.log(page.page,page.search,"page")
    return useQuery(
        ['master-listing-template-all-FetchAllPurchases-fetch', page, limit, search, queryParams],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/admin/purchases`,
                headers: {
                    'Authorization': `Bearer ${checkForAuthorization()}`
                },
                params: {
                    page,
                    limit,
                    search,
                    ...queryParams
                }
            })
        }, {
        // select: (data) => data,
        select: (data) => {
            // console.log(data,'values new')
            return data?.data
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchInvoices = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_STARTUP_BASE_URL}/admin/fetch-invoices`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                    'Content-type': 'application/json'
                },
                data: payload,
                // onUploadProgress: (data) => {
                //     setProgress(Math.round((data.loaded / data.total) * 100) == 100 ? 99 : Math.round((data.loaded / data.total) * 100));
                // }
            });
        },
        {
            retry: 0,
            // onSuccess: ()=>console.log("API successfull"),
            retry: (failureCount, error) => {
                return RetryOnError(failureCount, error)
            },
            onError: (err) => {
                // console.error(err);
                return verifyToken(err);
            }
        }
    );
};